import { render, staticRenderFns } from "./CategoryProductIds.vue?vue&type=template&id=13917548&"
import script from "./CategoryProductIds.vue?vue&type=script&lang=ts&"
export * from "./CategoryProductIds.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports